export default __webpack_public_path__ + "static/media/reports-1.2e5cf993.png";